// 状态筛选
export const STATUS_FILTER = [
  { value: '1', label: '待初查', quantity: 0 },
  { value: '2', label: '待复查', quantity: 0 },
  { value: '3', label: '待核查', quantity: 0 },
  { value: '4', label: '已结束', quantity: 0 },
]
// 状态筛选 - 详细
// vant 组件的字段得用text
export const STATUS_FILTER_DETAIL = [
  { value: '1', text: '待初查' },
  { value: '2', text: '待复查' },
  { value: '3', text: '待核查' },
  { value: '4', text: '已结束' },
]
// 初查&复查结果
export const RESULT_FL = [
  { value: '1', label: '合格' },
  { value: '2', label: '不合格' },
  { value: '3', label: '无展示' },
]
// 照片执行人 task 状态
export const MR_TASK_STATUS = [
  { value: '', label: '无数据', type: 'default' },
  { value: '', label: '无结论', type: 'default' },
  { value: '', label: '不合格 待复查', type: 'error' },
  { value: '', label: '无展示', type: 'error' },
  { value: '', label: '不合格', type: 'error' },
  { value: '', label: '合格', type: 'success' },
]
// 照片质量&服务质量
export const MR_TASK_IMG_SER_STATUS = [
  { value: '', label: '合格', type: 'success' },
  { value: '', label: '不合格', type: 'error' },
]
// 经理审查结果匹配规则
export const MD_VERIFY_RESULT_RULES = [
  // 经理核查的结果 1照片不合格 2照片合格-服务合格 3照片合格-服务无展示 4照片合格-服务不合格
  // 选项设计
  // 照片质量 1合格 2不合格
  // 服务质量 3合格 5不合格 8无展示
  {
    selectedValue: 2,
    resultValue: 1,
    radioColl: { photo: '不合格', service: null },
  }, // 2 + null = 2 照片不合格
  {
    selectedValue: 4,
    resultValue: 2,
    radioColl: { photo: '合格', service: '合格' },
  }, // 1 + 3 = 4 照片合格-服务合格
  {
    selectedValue: 9,
    resultValue: 3,
    radioColl: { photo: '合格', service: '无展示' },
  }, // 1 + 8 = 9 照片合格-服务无展示
  {
    selectedValue: 6,
    resultValue: 4,
    radioColl: { photo: '合格', service: '不合格' },
  }, // 1 + 5 = 6 照片合格-服务不合格
]

// 经理点击图片不合格的时候，固定弹出的提示语
export const PHOTO_NG_WARNING =
  '照片质量不合格，请立即与代表确认陈列服务真实性，必要时亲自实地走访要点，如确认需要扣款，请与药店签订补充协议！'
// 当代表提交任务的距离大于1km时提示
export const DISTANCE_NG = '警告！检测到当前合同所在地离你位置较远，是否确认提交？（请谨慎选择）'
